import { FC, useEffect, useState } from 'react';
import dayjs from 'dayjs';
// i18next
import { useTranslation } from 'react-i18next';
// Hooks
import useNavigateTo from 'hooks/useNavigateTo';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectTimer } from 'store/pages/pagesSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectPreviewPageMode } from 'store/player/playerSelectors';
import QuizTypes from 'types/QuizTypes';
import TimerTypes from 'types/TimerTypes';
// Components
import AppBar from 'components/AppBar';
import Countdown from 'components/Countdown';
// Utilities
import { getTimeRemaining } from 'utilities/Utilities';

let timeout:any = null;
let interval:any = null;
const intervalTime = 1000;

const TimerPage:FC = () => {
  const { t } = useTranslation();

  const quiz = useAppSelector(selectQuiz);
  const timer = useAppSelector(selectTimer);
  const previewPageMode = useAppSelector(selectPreviewPageMode);

  const date = dayjs();
  const timeoutTime = timer?.type === TimerTypes.Relative ? (Number(timer?.time) || 0) * 1000 : (Number(timer?.time) || 0) - new Date().getTime();

  const navigateTo = useNavigateTo();

  const [time, setTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });


  const handleTime = () => {
    if (!timer) return;
    const now = dayjs();
    const end = timer.type === TimerTypes.Relative ? date.add(Number(timer.time), 'seconds') : dayjs(Number(timer.time))

    const remaining = getTimeRemaining(now, end);

    setTime(remaining);
  }

  useEffect(() => {
    if (!timer || timeoutTime <= 0) navigateTo('pages-handler');

    handleTime();

    if (previewPageMode) return;

    if ( timeout ) clearTimeout(timeout);
    if ( interval ) clearInterval(interval);

    interval = setInterval(handleTime, intervalTime);
    
    timeout = setTimeout(() => {
      navigateTo('pages-handler');
    }, timeoutTime);

    return () => {
      if ( timeout ) clearTimeout(timeout);
      if ( interval ) clearInterval(interval);
    }
    // eslint-disable-next-line
  }, []);

  const Image:FC = () => {
    if (!timer || !timer.image) return null;
    return (
      <img
        className="relative z-10 shadow-primary rounded-lg"
        src={timer?.image}
        alt=""
      />
    )
  }

  const scoreVisible = [QuizTypes.BeatTheExpert, QuizTypes.Scoring, QuizTypes.Streak].includes(quiz.type);

  if (!timer) return null;
  return (
    <div
      className="h-full flex flex-col p-4"
      style={{ background: quiz.backgroundImage ? `url('${quiz.backgroundImage}') center / cover` : '' }}
    >
      <AppBar scoreVisible={scoreVisible} />
      <div className="grow flex flex-col justify-center items-center gap-6 py-4">
        {timer.title ? (
          <h2 className="font-semibold text-lg text-primary text-center">{timer.title}</h2>
        ) : null}
        {timer.url ? (
          <a href={timer.url} target="_blank" rel="noreferrer">
            <Image />
          </a>
        ) : <Image />}
        <p className="font-semibold text-lg text-primary">{t('pages.timer.title')}</p>
        <Countdown
          isInitialized
          days={time.days}
          hours={time.hours}
          minutes={time.minutes}
          seconds={time.seconds}
          variant="card"
        />
        <p className="text-primary text-xs text-center font-semibold">{t('pages.timer.hint')}</p>
      </div>
    </div>
  )
}

export default TimerPage;
